import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
	CssBaseline,
	List,
	ListItem,
	ListItemText,
	ListItemIcon,
	Divider,
	Drawer,
	Toolbar,
	Box,
	withStyles,
	IconButton,
	Tooltip
} from '@material-ui/core'
import WebIcon from '@material-ui/icons/Web';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { Omit } from '@material-ui/types';
import PeopleIcon from '@material-ui/icons/People';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import SettingsIcon from '@material-ui/icons/Settings';
import HelpIcon from '@material-ui/icons/Help';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import MenuIcon from '@material-ui/icons/Menu';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';

import LoopLogoWhite from '../../assets/loop_white_FA.svg';

/*
* typescript defs
*/

interface Props {
	logout: () => void,
}

interface ListItemLinkProps {
	icon?: React.ReactElement;
	primary: string;
	to: string;
	tooltip: boolean
}
/*
* Fragment Defs
*/

const LoopToolTip = withStyles({
	tooltip: {
		fontSize: "16px",
		marginLeft: "-170px"
	}
})(Tooltip);

function ListItemLink(props: ListItemLinkProps) {
	const { icon, primary, to, tooltip } = props;

	const renderLink = React.useMemo(
		() =>
			React.forwardRef<any, Omit<RouterLinkProps, 'to'>>((itemProps, ref) => (
				<RouterLink to={to} ref={ref} {...itemProps} />
			)),
		[to],
	);

	const menu = <ListItem button component={renderLink} style={{
		width: drawerWidth
	}}>
		{icon ? <ListItemIcon style={{ minWidth: iconWidth + "px" }}>{icon}</ListItemIcon> : null}
		<ListItemText primary={primary} />
	</ListItem>;

	return (
		<li>
			{tooltip ? <LoopToolTip title={primary} arrow placement="right" >{menu}</LoopToolTip> : menu}
		</li>
	);
}


/*
* component defs
*/

const drawerWidth = 240;
const iconWidth = 45;

function Sidebar(props: Props) {
	const classes = useStyles();
	const [open, setOpen] = useState<boolean>(true);
	return (
		<React.Fragment>
			<CssBaseline />
			<Drawer
				className={`${open ? classes.drawerOpen : classes.drawerClosed} ${classes.drawerBase}`}
				variant="permanent"
				classes={{
					paper: `${open ? classes.drawerOpen : classes.drawerClosed} ${classes.drawerPaperBase}`,
				}}
			>
				<Toolbar className={classes.toolbar} />
				<div className={classes.drawerContainer}>
					<Box display="flex" width={drawerWidth} alignItems="center">
						<Box pt={2} minWidth={iconWidth + 12} textAlign="center">
							<IconButton onClick={() => setOpen(!open)}>
								{open ? <MenuOpenIcon className={classes.drawerListIcon} /> : <MenuIcon className={classes.drawerListIcon} />}
							</IconButton>
						</Box>
					</Box>
					<List>
						<Divider style={{ backgroundColor: "rgba(255,255,255,0.5)", marginBottom: "1em" }} />
						<ListItemLink tooltip={!open} to="/#customer" primary="Home" icon={<WebIcon className={classes.drawerListIcon} />} />
						<ListItemLink tooltip={!open} to="/#customer" primary="Customers" icon={<PeopleIcon className={classes.drawerListIcon} />} />
						<ListItemLink tooltip={!open} to="/#address" primary="Properties" icon={<HomeWorkIcon className={classes.drawerListIcon} />} />
						<ListItemLink tooltip={!open} to="/servicerequest" primary="New Service Request" icon={<SettingsIcon className={classes.drawerListIcon} />} />
						<ListItemLink tooltip={!open} to="/waste/jobs" primary="Waste Operations" icon={<LocalShippingIcon className={classes.drawerListIcon} />} />
						<ListItem button component="a" target="_blank" href="http://ishare/sites/OurCustomer/SitePages/Knowledge%20Base.aspx ">
							<ListItemIcon style={{ minWidth: iconWidth + "px" }}><HelpIcon className={classes.drawerListIcon} /></ListItemIcon>
							<ListItemText primary="Knowledgebase" />
						</ListItem>
					</List>
					<Box px={1} position="absolute" width="100%" bottom="0" textAlign="center" marginBottom={3}>
						<img src={LoopLogoWhite} alt="loop logo" style={{
							width: "100%",
							height: "auto",
							maxWidth: "120px"
						}} />
					</Box>
				</div>
			</Drawer>
		</React.Fragment>
	);
}

/*
* styles
*/

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
	},
	drawerBase: {
		flexShrink: 0,
		transition: "width 200ms",
		overflow: "hidden"
	},
	drawerPaperBase: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.primary.contrastText,
		transition: "width 200ms"
	},
	drawerOpen: {
		width: drawerWidth,
	},
	drawerClosed: {
		width: "60px"
	},
	drawerListIcon: {
		color: theme.palette.primary.contrastText
	},
	drawerContainer: {
		overflow: 'auto',
		height: "100%",
		overflowX: "hidden"
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
	},
	userID: {
		height: "80px",
		paddingTop: "1.5em",
		textTransform: "uppercase",
	},
	toolbar: {
		height: "90px"
	}
}));

export default Sidebar;
